import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../utils/redux/slices/userSlice";
import * as z from "zod";

const useCustomFormHook = () => {
  const [hookTypeUser, setHookTypeUser] = useState("private");
  const [typeUser, setTypeUser] = useState("private");
  const [pecExist, setPecExist] = useState("");
  const [sdiCodeExist, setSdiCodeExist] = useState("");
  const [formData, setFormData] = useState({});
  const [countryRef, setCountryRef] = useState();

  useEffect(() => {
    setTypeUser(hookTypeUser);
  }, [hookTypeUser, countryRef]);

  const userSchemaItaly = z.object({
    companyname: z
      .string()
      .min(1, { message: "companyname must have at least 3 char." }),
    country: z.union([
      z.string().min(1, { message: "Country must have at least 3 char." }),
      z.number().min(1, { message: "Country must have at least 3 char." }),
    ]),
    postalcode: z
      .string()
      .min(5, { message: "CAP must have at least 3 char." }),
    city: z.union([
      z.string().min(1, { message: "City must have at least 3 char." }),
      z.number().min(1, { message: "City must have at least 3 char." }),
    ]),
    address: z
      .string()
      .min(1, { message: "Address must have at least 3 char." }),
    email: z.string().email({ message: "Invalid email." }),
    // phone: z.string().min(13, { message: "Phon must have at least 13 char." }),
    fiscalcode: z.string().min(1, { message: "Fiscal code is required." }),
    vatnumber: z.string().min(1, { message: "Required." }),
    sdi_code: z
      .string()
      [pecExist ? "optional" : "min"](1, { message: "SDI code is required." }),
    pec: z
      .string()
      [sdiCodeExist ? "optional" : "min"](1, { message: "PEC is required." }),
    referrer: z.string(),
    phone: z.string().optional(),
    metamask: z.string().optional(),
    province: z.union([
      z.string().min(1, { message: "Province must have at least 3 char." }),
      z.number().min(1, { message: "Province must have at least 3 char." }),
    ]),
  });

  const userSchemaCompany = z.object({
    companyname: z
      .string()
      .min(1, { message: "companyname must have at least 3 char." }),
    country: z.union([
      z.string().min(1, { message: "Country must have at least 3 char." }),
      z.number().min(1, { message: "Country must have at least 3 char." }),
    ]),
    postalcode: z
      .string()
      .min(5, { message: "CAP must have at least 3 char." }),
    city: z.union([
      z.string().min(1, { message: "City must have at least 3 char." }),
      z.number().min(1, { message: "City must have at least 3 char." }),
    ]),
    address: z
      .string()
      .min(1, { message: "Address must have at least 3 char." }),
    email: z.string().email({ message: "Invalid email." }),
    // phone: z.string().min(13, { message: "Phon must have at least 13 char." }),
    fiscalcode: z.string().min(1, { message: "Fiscal code is required." }),
    vatnumber: z.string().min(1, { message: "Required." }),
    sdi_code: z.string().optional(),
    pec: z.string().optional(),
    referrer: z.string(),
    phone: z.string().optional(),
    metamask: z.string().optional(),
    province: z.union([
      z.string().min(1, { message: "Province must have at least 3 char." }),
      z.number().min(1, { message: "Province must have at least 3 char." }),
    ]),
  });

  const userSchemaUser = z.object({
    firstname: z
      .string()
      .min(1, { message: "First name must have at least 3 char." }),
    lastname: z
      .string()
      .min(1, { message: "Last name must have at least 3 char." }),
    country: z.union([
      z.string().min(1, { message: "Country must have at least 3 char." }),
      z.number().min(1, { message: "Country must have at least 3 char." }),
    ]),
    postalcode: z
      .string()
      .min(5, { message: "CAP must have at least 3 char." }),
    city: z.union([
      z.string().min(1, { message: "City must have at least 3 char." }),
      z.number().min(1, { message: "City must have at least 3 char." }),
    ]),
    address: z
      .string()
      .min(1, { message: "Address must have at least 3 char." }),
    email: z.string().email({ message: "Invalid email." }),
    // phone: z.string().min(13, { message: "Phon must have at least 13 char." }),
    fiscalcode: z.string().min(1, { message: "Fiscal code is required." }),
    referrer: z.string(),
    phone: z.string().optional(),
    metamask: z.string().optional(),
    province: z.union([
      z.string().min(1, { message: "Province must have at least 3 char." }),
      z.number().min(1, { message: "Province must have at least 3 char." }),
    ]),
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    resolver: zodResolver(
      typeUser === "private"
        ? userSchemaUser
        : typeUser === "company" && countryRef === "IT"
        ? userSchemaItaly
        : userSchemaCompany
    ),
  });

  const useractual = useSelector((state) => state?.user?.user?.data);

  const [referrer, setReferrer] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();

  const watchedData = watch();

  useEffect(() => {
    if (
      watchedData.referrer !== formData.referrer ||
      watchedData.firstname !== formData.firstname ||
      watchedData.email !== formData.email ||
      watchedData.country !== formData.country ||
      watchedData.postalcode !== formData.postalcode ||
      watchedData.city !== formData.city ||
      watchedData.address !== formData.address ||
      watchedData.phone !== formData.phone ||
      watchedData.fiscalcode !== formData.fiscalcode ||
      watchedData.vatnumber !== formData.vatnumber ||
      watchedData.sdi_code !== formData.sdi_code ||
      watchedData.pec !== formData.pec ||
      watchedData.metamask !== formData.metamask ||
      watchedData.province !== formData.province
      // Aggiungi altre proprietà se necessario
    ) {
      setFormData((prevData) => ({ ...prevData, ...watchedData }));
      setSdiCodeExist(watchedData.sdi_code);
      setPecExist(watchedData.pec);
    }
  }, [watchedData]);

  useEffect(() => {
    const actualTokenLocal = localStorage.getItem("token");
    if (actualTokenLocal) {
      dispatch(getUser(actualTokenLocal));
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const referrerValue = queryParams.get("referrer");

    if (referrerValue) {
      setValue("referrer", referrerValue);
      setReferrer(referrerValue);
    }
  }, [location.search, setValue]);

  useEffect(() => {
    if (useractual) {
      console.log("useractual province", useractual);
      setValue("email", useractual?.email);
      setValue("companyname", useractual?.company_name);
      setValue("firstname", useractual?.profile?.data?.firstName);
      setValue("lastname", useractual?.profile?.data?.lastName);
      // setValue("country", useractual?.profile?.data?.country?.data?.code);
      setValue(
        "postalcode",
        useractual?.user?.data?.billingaddress?.data?.postcode
      );
      // setValue("city", useractual?.user?.data?.billingaddress?.data?.city_id);
      setValue("address", useractual?.user?.data?.billingaddress?.data?.street);
      setValue(
        "phone",
        useractual?.user?.data?.billingaddress?.data?.phone_number
      );
      setValue("fiscalcode", useractual?.user?.data?.cf);
      setValue("vatnumber", useractual?.user?.data?.vat_number);
      setValue("sdi_code", useractual?.user?.data?.sdi_code);
      setValue("pec", useractual?.user?.data?.pec);
      // setValue(
      //   "province",
      //   useractual?.user?.data?.billingaddress?.data?.province
      // );
      // trigger();
    } else {
      setValue("email", "");
      setValue("companyname", "");
      setValue("firstname", "");
      setValue("lastname", "");
      setValue("country", "");
      setValue("postalcode", "");
      setValue("city", "");
      setValue("province", "");
      setValue("address", "");
      setValue("phone", "");
      setValue("fiscalcode", "");
      setValue("vatnumber", "");
      setValue("sdi_code", "");
      setValue("pec", "");
    }
  }, [useractual, setValue, trigger]);

  return {
    register,
    handleSubmit,
    setValue,
    errors,
    referrer,
    setHookTypeUser,
    isValid,
    formData,
    setCountryRef,
  };
};

export default useCustomFormHook;
